/// <amd-module name="TFS/TeamProfilePanel/Models" />
// TODO: Convert to genclient
export interface ITeamPanelContext {
    projectId: string;
    projectName: string;
    teamId: string;
    teamName: string;
}

export interface ITeamPanelDataProviderResponse {
    items: ITeamPanelItem[];
    error?: string;
}

export interface ITeamPanelItem {
    artifactId: string;
    href: string;
    iconClassName: string;
    name: string;
    title: string;
}

export interface ITeamPanelItemView {
    hub: string;
    item: ITeamPanelItem;
}